import React from "react"
import { Image, Flex } from "rebass"

import Reveal from '../reveals'
import RowWrapper from "./RowWrapper"
import ButtonsNav from "./ButtonsNav"

const RowHeaderComponent = ({ data }) => {
  const { image, buttonsButtons, revealAnimation } = data

  return (
    <RowWrapper {...data}>
      <Reveal animation={revealAnimation} delay={0}>
        <Flex alignItems="center" justifyContent="space-between">
          {image && <Image src={image.sourceUrl} width={["50%", "50%", "40%", "18%"]} alt="Logo" />}
          {buttonsButtons && <ButtonsNav data={buttonsButtons} />}
        </Flex>
      </Reveal>
    </RowWrapper>
  )
}

export default RowHeaderComponent
